import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalTaxCreateProps {}

const ModalTaxCreate = ({}: ModalTaxCreateProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.createTax');
  const onClose = () => {
    closeSingleModal('createTax');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Nova taxa"
      height={'auto'}
      width={'60vw'}
    >
      <Form.Export.Tax.Create />
    </Modal>
  );
};

export default ModalTaxCreate;
